import React from 'react'
import { LiveCTAs } from './LiveCTAs'
import { ComingSoonEmailCapture } from './ComingSoon'

export interface CtaStrategyProps {
  camp: {
    slug: string
    isLive: boolean
  }
}

export const CtaStrategy = ({ camp }: CtaStrategyProps) => (
  <>
    {camp.isLive ? (
      <LiveCTAs slug={camp.slug} />
    ) : (
      <ComingSoonEmailCapture slug={camp.slug} />
    )}
  </>
)
